import { useEffect, useState } from 'react'
import { fetchAssets } from '../../infrastructure/api/assetsApi'
import type { AssetsResponse } from '../../domain/canvas/value-objects/asset'

export const useQueryAssets = () => {
  const [assets, setAssets] = useState<AssetsResponse | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const loadAssets = async () => {
      setIsLoading(true)
      setError(null)

      try {
        const data = await fetchAssets()
        setAssets(data)
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to load assets'))
      } finally {
        setIsLoading(false)
      }
    }

    loadAssets()
  }, [])

  return {
    assets,
    isLoading,
    error,
  }
}
